/* eslint-disable react/no-unknown-property */
import React, { useContext } from 'react'
import { ProjectContext } from '../../../context/ProjectContext'
import { StarsFilter } from '../overview/filters/stars'
import { MeetingsFilter } from '../overview/filters/meetings'
import { SortFilter } from '../overview/filters/sortFilter'
import { Feedbacks } from './feedbacks'
import FiltersIcon from '../../icons/Filters'
import { EmptyState } from './EmptyState'

export function FeedbacksIndex() {
  const { isLoading, filteredFeedbacks, feedbacksFilters, setFeedbacksFilters, project } = useContext(ProjectContext)

  return (
    <div className="px-[50px] py-[30px] w-full overflow-y-auto">
      <div className="w-full mb-[15px] flex justify-between items-center">
        <p className="text-[#3f424a] text-[26px] font-semibold font-['Manrope'] leading-[29.90px] mr-4">Feedbacks</p>
        <div className="w-auto h-12 bg-white rounded-[10px] flex items-center" style={{ whiteSpace: 'nowrap' }}>
          <div className="relative border-r border-[#e4e4e4] flex justify-center items-center">
            <div className="py-3.5 px-5 flex justify-center items-center gap-1">
              <FiltersIcon />
              <p className="text-black text-base font-bold font-['Manrope'] leading-tight ms-1">FILTERS</p>
            </div>
          </div>
          <StarsFilter filters={feedbacksFilters} setFilters={setFeedbacksFilters} label={'Feedback'} />
          <MeetingsFilter filters={feedbacksFilters} setFilters={setFeedbacksFilters} />
          <SortFilter filters={feedbacksFilters} setFilters={setFeedbacksFilters} />
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-[calc(100%-40px)]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#FF4A8E]"></div>
        </div>
      ) : filteredFeedbacks.length > 0 ? (
        <Feedbacks feedbacks={filteredFeedbacks} />
      ) : (
        <EmptyState project={project} />
      )}
    </div>
  )
}
